<template>
  <div class="pa-park-list-no-content-view">
    <div class="pa-icon" :class="iconClass">
      <slot name="icon" />
    </div>
    <p class="pa-text">{{text}}</p>
    <p class="pa-caption-text">{{caption}}</p>
  </div>
</template>

<script>
export default {
  props : {
    text : {
      default: null
    },

    caption : {
      default: null
    },

    iconClass : {
      default: () => {
        return [];
      }
    }
  },
}
</script>

<style lang="scss">
.pa-park-list-no-content-view{
  text-align: center;
  color:#aa875e;
  padding:2rem 0;

  .pa-icon{
    width:30%;
    margin:0 auto .2rem;

    svg{
      path{
        fill:#B5946C !important;
        stroke:#B5946C !important;
      }
    }

    &-slash{
      width:30%;
    }

    &-clip{
      width:15%;
    }
  }

  .pa-text{
    font-size:1rem;
  }
  
  .pa-caption-text{
    font-size: .8rem;;
  }
}
</style>